import RuleService from '@/services/RuleService'

const state = () => ({
  menu: [],
  article: {
    number: null,
    title: null,
    content: null
  }
})

const getters = {}

const actions = {
  async GET_MENU ({ commit }) {
    try {
      const response = await RuleService.menu()
      commit('SET_MENU', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_ARTICLE ({ commit }, article) {
    try {
      const response = await RuleService.article(article)
      commit('SET_ARTICLE', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  }
}

const mutations = {
  SET_MENU (state, data) {
    state.menu = data.menu.map(item => { return Object.assign({}, item) })
  },
  SET_ARTICLE (state, data) {
    state.article = Object.assign({}, data.article)
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/rules.js